export default __webpack_public_path__ + "static/media/benin.cb23e569.png";